import { IUserConsent } from '../types';
import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useCreateUserConsentMutation<D extends IUserConsent>(params?: HydraMutationParams) {
  return useHydraMutation('api/user_consents', params);
}
